











































































































import { Analytics as AnalyticsSDK } from '@superbet-group/web.analytics.sdk';
import {
    SdsBadge,
    SdsIcon,
} from '@superbet-group/web.lib.ui-components';
import {
    defineComponent,
    onMounted,
    ref,
} from '@vue/composition-api';

import SuperBonusV2 from './SuperBonusV2.vue';
import { featureFlagService } from '@superbet-group/web.lib.flags';

export default defineComponent({
    name: 'BetSlipCompact',
    emits: ['expand'],
    props: {
        coefficient: {
            type: Number,
            required: true,
        },
        stake: {
            type: Number,
            required: false,
            default: 0,
        },
        numberOfEvents: {
            type: Number,
            default: 1,
        },
        potentialWin: {
            type: Number,
            required: true,
        },
        totalNumberOfSelectedCombinations: {
            type: Number,
            default: 0,
        },
        isSimple: {
            type: Boolean,
            required: true,
        },
        isSuperBonusVisible: {
            type: Boolean,
            required: true,
        },
        isEligible: {
            type: Boolean,
            required: true,
        },
        isUnlocked: {
            type: Boolean,
            required: true,
        },
        selections: {
            type: Number,
            required: true,
        },
        selectionsForFirstBonus: {
            type: Number,
            required: true,
        },
        selectionsNeededForNext: {
            type: Number,
            required: true,
        },
        nextPercentage: {
            type: Number,
            required: true,
        },
        percentage: {
            type: Number,
            required: true,
        },
        maximumPercentage: {
            type: Number,
            required: true,
        },
        isBoosted: {
            type: Boolean,
            required: false,
        },
        isSocialOnly: {
            type: Boolean,
            required: false,
            default: false,
        },
        notEligibleReason: {
            type: String,
            required: false,
            default: '',
        },
    },
    computed: {
        totalQuotaOrNumberOfCombinationsLabel(): string {
            return this.isSimple ? 'quote' : 'combinations';
        },
        totalQuotaOrNumberOfCombinations(): string | number {
            if (this.isSimple) {
                return this.$formatOddValue(this.coefficient);
            }
            return this.totalNumberOfSelectedCombinations;
        },
        stakeFormatted(): string {
            return this.$currency(this.stake);
        },
    },
    methods: {
        onBetslipExpand() {
            AnalyticsSDK.getInstance().log('Betslip_Open');
            this.$emit('expand');
        },
    },
    setup() {
        const isSuperBonusV2Enabled = ref(false);
        const isPriceBoostV1Enabled = ref(false);

        onMounted(async () => {
            isSuperBonusV2Enabled.value = await featureFlagService.getFeatureValue('bex.generosity.superbonus-v2', false);
            isPriceBoostV1Enabled.value = await featureFlagService.getFeatureValue('bex.generosity.price-boost-v-1', false);
        });

        return {
            isSuperBonusV2Enabled,
            isPriceBoostV1Enabled,
        };
    },
    components: {
        SdsBadge,
        SdsIcon,
        SuperBonusV2,
    },
});
